"use client"

import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Pagination, Autoplay } from "swiper/modules"
import { useRef } from "react"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/effect-coverflow"
import "./ImageSliderSection.css"
import Design2 from "../../images/Design2.png"
import Design3 from "../../images/Design3.png"
import Design4 from "../../images/Design4.png"
import Design5 from "../../images/Design5.png"
import Design6 from "../../images/Design6.png"
import Design7 from "../../images/Design7.png"
import Design8 from "../../images/Design8.png"
import logo from "../../images/imperia-logo.png"
import { Link } from 'react-router-dom';

const ImageSliderSection = () => {
    const swiperRef = useRef(null)

    // Landscape sample data - replace with your actual content
    const slides = [
        {
            id: 1,
            image: Design5 || logo,
            title: "Hydraulic Power Steering",
            subtitle: "Power Steering Hoses",
            description: "Wide Range of Power Steering Hoses",
            category: "Automobile",
            gradient: "from-indigo-500 to-blue-700",
            categoryId: "DA3446",

        },
        {
            id: 2,
            image: Design3 || logo,
            title: "Silicon High Temperature Hoses",
            subtitle: "Silicon Hoses",
            description: "Silicon High Temperature Hoses engineered with Rayon and Wire Over braid for extreme temperatures and pressure , ensuring performance and durability across automotive and Railway applications ",
            category: "Silicon charge Air Cooler/Intercooler Assembly",
            gradient: "from-cyan-500 to-blue-600",
            categoryId: "1AEBF2",

        },
        {
            id: 3,
            image: Design4 || logo,
            title: "Brake & Clutch Assembly",
            subtitle: "Brake Hoses",
            description: "Brake & Clutch Assemblies engineered using PTEE, Rubber, Polyamide, Metal & PA",
            category: "Automobile",
            gradient: "from-blue-600 to-purple-600",
            categoryId: "DA3446",
        },
        {
            id: 4,
            image: Design2 || logo,
            title: "Hoses for Various Industries",
            subtitle: "NBR Hoses",
            description: "Air/ Water/ Coolant Fuel Hose. Each engineered for specific application & environment.",
            category: "Hardware & Industry / General Purpose Hoses",
            gradient: "from-blue-500 to-indigo-600",
            categoryId: "AAAB3E",
        },
        {
            id: 5,
            image: Design6 || logo,
            title: "Hydraulic Hose Assemblies And Allied Fittings",
            subtitle: "High Pressure Hoses & End Fittings",
            description: "Wide range of Hydraulic Hose engineered with tensile Steel or Rayon wore over braid along with Allied End Fittings for various industries.",
            category: "Industrial & Automobile Hoses",
            gradient: "from-sky-500 to-blue-600",
            categoryId: "AAAB3E",
        },
        {
            id: 6,
            image: Design7 || logo,
            subtitle: "Fuel Injection Assemblies",
            title: "High Pressure Steel Tube Assemblies",
            description: "High pressure Tubes engineered with Seamless Stainless Steel SS and Seamless cold Draw steel CDS used in Automobile and other industries ",
            category: "Automobile & Industrial",
            gradient: "from-sky-500 to-blue-600",
            categoryId: "DA3446",
        },
        {
            id: 8,
            image: Design8 || logo,
            title: "Air Brake Coiled Hose",
            subtitle: "Penumatic Coiled Hoses",
            description: "Wide range of Coiled Hoses engineered with Virgin Nylon, PU, PE used in Automobile, Pneumatic, Medical & Other industries ",
            category: "Industrial, Medical & Automobile",
            gradient: "from-sky-500 to-blue-600",
            categoryId: "C8045E",
        },
    ]

    const handleCardMouseEnter = () => {
        if (swiperRef.current && swiperRef.current.autoplay) {
            swiperRef.current.autoplay.stop()
        }
    }

    const handleCardMouseLeave = () => {
        if (swiperRef.current && swiperRef.current.autoplay) {
            swiperRef.current.autoplay.start()
        }
    }

    return (
        <section className="modern-slider-section light-theme">
            {/* Background Elements */}
            <div className="bg-elements">
                <div className="bg-gradient-1"></div>
                <div className="bg-gradient-2"></div>
                <div className="floating-shapes">
                    <div className="shape shape-1"></div>
                    <div className="shape shape-2"></div>
                    <div className="shape shape-3"></div>
                </div>
            </div>

            <div className="container">
                {/* Modern Header */}
                <div className="section-header">
                    <h2 className="section-title">
                        Your Hoses Partner
                    </h2>
                </div>

                {/* Modern Slider */}
                <div className="slider-wrapper">
                    <Swiper
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper
                        }}
                        modules={[Navigation, Pagination, Autoplay]}
                        spaceBetween={40}
                        slidesPerView={3}
                        centeredSlides={false}
                        navigation={{
                            nextEl: ".modern-nav-next",
                            prevEl: ".modern-nav-prev",
                        }}
                        pagination={{
                            el: ".modern-pagination",
                            clickable: true,
                            renderBullet: (index, className) =>
                                `<span class="${className}"><span class="bullet-inner"></span></span>`,
                        }}
                        autoplay={{
                            delay: 2000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: false,
                        }}
                        loop={true}
                        speed={800}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 30,
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 40,
                            },
                        }}
                        className="modern-swiper"
                    >
                        {slides.map((slide) => (
                            <SwiperSlide key={slide.id}>
                                <Link
                                    to="/market/products"
                                    state={{ categoryId: slide.categoryId, categoryName: slide.categoryName }}
                                >
                                    <div className="modern-slide" onMouseEnter={handleCardMouseEnter} onMouseLeave={handleCardMouseLeave}>
                                        <div className="slide-image-wrapper">
                                            <img
                                                src={slide.image || "/placeholder.svg"}
                                                alt={slide.title}
                                                className="slide-image"
                                                loading="lazy"
                                            />
                                            <div className={`slide-gradient bg-gradient-to-br ${slide.gradient}`}></div>
                                        </div>

                                        <div className="slide-content">
                                            <div className="content-header">
                                                <span className="slide-category">{slide.category}</span>
                                                {/* <div className="category-dot"></div> */}
                                            </div>

                                            <h3 className="slide-title">{slide.title}</h3>
                                            <p className="slide-subtitle">{slide.subtitle}</p>
                                            <p className="slide-description">{slide.description}</p>

                                            {/* <div className="slide-footer">
                                            <button className="explore-btn">
                                                <span>Explore</span>
                                                <svg className="btn-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path
                                                        d="M6 12L10 8L6 4"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </button>
                                        </div> */}
                                        </div>
                                    </div>
                                </Link >

                            </SwiperSlide>
                        ))}
                    </Swiper>

                    {/* Modern Navigation */}
                    <div className="modern-navigation">
                        <button className="modern-nav-btn modern-nav-prev">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M15 18L9 12L15 6"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                        <button className="modern-nav-btn modern-nav-next">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M9 18L15 12L9 6"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    </div>

                    {/* Modern Pagination */}
                    <div className="modern-pagination"></div>
                </div>
            </div>
        </section>
    )
}

export default ImageSliderSection
